<template>
  <v-container fluid id="NewWorkOrder" v-if="workOrder">
    <v-row wrap>
      <v-col cols="12" class="headline">
        <!-- <v-btn color="primary" small outlined text to="/work-orders/orders"
          ><v-icon small left>chevron_left</v-icon>Work Orders</v-btn
        > -->
        <!-- cancel order -->
        <v-dialog v-model="cancelWorkOrderDialog" width="600">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="workOrder.status == 'open'"
              class="elevation-0"
              dark
              small
              color="grey darken-2"
              v-on="on"
              @click="cancelWorkOrderDialog = true"
            >
              <v-icon small class="mr-2">cancel</v-icon>Cancel Work Order
            </v-btn>
          </template>

          <v-card class="pa-2">
            <v-card-title class="title lighten-2" primary-title>
              Cancel Work Order
            </v-card-title>

            <v-card-text>
              Are you sure you want to cancel this work order?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cancelWorkOrderDialog = false"
                >Close</v-btn
              >
              <v-btn color="primary" @click="cancelWorkOrder">
                Cancel Work Order
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <!-- JOB DETAILS -->
    <v-row>
      <v-col cols="12">
        <work-order-ticket :workOrder="workOrder" />
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :timeout="5000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import workOrderTicket from "@/components/workOrders/WorkOrderTicket";
export default {
  components: {
    workOrderTicket: workOrderTicket,
  },
  data() {
    return {
      workOrder: null,
      cancelWorkOrderDialog: false,
      snack: false,
      snackColor: "",
      snackText: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  async created() {
    this.getOrder();
  },
  methods: {
    async getOrder() {
      try {
        let workOrder = await fb.db
          .collection("workOrders")
          .doc(this.$route.params.orderNumber)
          .get();
        debugger;
        workOrder = workOrder.data();
        this.workOrder = workOrder;
        console.log(this.workOrder);
      } catch (error) {
        alert("Error getting work order.");
        console.log(error);
      }
    },
    async cancelWorkOrder() {
      await fb.db
        .collection("workOrders")
        .doc(this.$route.params.orderNumber)
        .update({
          status: "cancelled",
        });
      this.cancelWorkOrderDialog = false;
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Successfully Cancelled Work Order!";
      this.getOrder();
    },
  },
};
</script>

<style scoped>
.small-col {
  width: 60px;
}
@media (min-width: 600px) {
  .small-col {
    width: 90px;
  }
}
</style>
